import { AxiosInstance } from 'axios'

const responseInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response: any) => {
      if (response.data) {
        const { data } = response
        return data
      }
      return response
    },
    (error) => {
      return error.response || error
    }
  )
}

export default responseInterceptor
